import { makeStyles, tokens } from '@fluentui/react-components';

export const useServiceFormStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingVerticalL
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM
  },
  rowContainer: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap'
  },
  flexField: {
    flex: 1,
    minWidth: '200px'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: tokens.spacingVerticalXL
  },
  fieldWithButton: {
    display: 'flex',
    gap: tokens.spacingHorizontalXS,
    alignItems: 'center'
  },
  dropdownWithButton: {
    flex: 1
  },
  stickyMessageBar: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    backgroundColor: tokens.colorNeutralBackground1,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    marginBottom: tokens.spacingVerticalM
  },
  errorList: {
    margin: `${tokens.spacingVerticalS} 0`,
    paddingLeft: tokens.spacingHorizontalL,
    '& li': {
      marginBottom: tokens.spacingVerticalXS
    }
  }
});
